import {download, get, getArray, post} from '../index'

export default {
  getPendientes: (params) => getArray('verifactu/pendientes', params),
  getEnviadas: () => getArray('verifactu/enviadas'),
  enviarRequerimiento: (request) => post('verifactu/requerimiento', request),
  downloadPeticion: (idFactura) => download('verifactu/peticion/' + idFactura, { format: 'application/xml' }),
  getRegistrosComprobables: () => getArray('verifactu/huella/registros'),
  comprobarHuellaFactura: (idFactura) => get('verifactu/huella/factura/' + idFactura),
  comprobarHuellaEvento: (id) => get('verifactu/huella/evento/' + id),
  exportarRegistros: (params) => post('verifactu/export/registros', undefined, params)
}
